<template>
	<div class="route-auth">
		<div style="min-width: 250px; margin: 0 auto;">
			<div class="title">
				Access is limited
			</div>

			<form action="" method="POST" class="w" @submit.stop.prevent="tryAuth">
				<div class="mt-5">
					<div class="form-group">
						<label class="control-label" for="username">Username</label>
						<input v-model.trim="login" type="text" placeholder="" title="Please enter you username" required class="form-control">
					</div>
					<div class="form-group">
						<label class="control-label" for="password">Password</label>
						<input v-model.trim="pass" type="password" title="Please enter your password" placeholder="******" required class="form-control" autocomplete="current-password">
					</div>
				</div>

				<div class="button-row mt-3">
					<button class="btn-success btn-block" :disabled="loading">
						<font-awesome-icon v-if="loading" icon="spinner" spin />
						Login
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script setup lang="ts">
import { inject, ref } from 'vue';
import type { AxiosInstance } from 'axios';

const axios = inject<AxiosInstance>('axios')!

// Reactives
const loading = ref(false)
const login = ref("")
const pass = ref("")

// Methods
function tryAuth(){
	loading.value = true

	// Check for server connection
	axios.post('/api/user-side/auth', {
		login: login.value,
		pass: pass.value
	})
		.then(() => window.location.reload())
		.catch(() => loading.value = false)
}
</script>
